<template>
  <div class="content">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <slot name="header">
            <b-badge variant="info">3 / 4</b-badge>
            <h3 class="mb-0">Monitor third-party components.</h3>
            <p class="text-sm mb-0">
              You can also monitor
              <mark style="font-weight: 600;">third-party components</mark>
              . We integrate with hundreds of company's status pages, so we know
              whether any of your dependencies have real (or planned) downtime.
            </p>
            <br />
            <p class="text-sm mb-0">
              If any are missing,
              <a href="mailto:hello@boltscale.com">let us know.</a>
              We're adding APIs all the time.
            </p>
          </slot>
        </template>
        <div>
          <b-col>
            <div>
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                placeholder="Search..."
              ></base-input>
            </div>
          </b-col>
          <el-table
            ref="fuck"
            :data="queriedData"
            row-key="id"
            header-row-class-name="thead-light"
            @sort-change="sortChange"
            @select="selectionChange"
          >
            <el-table-column
              reserve-selection
              prop="selected"
              type="selection"
              :selectable="isRowSelectable"
            ></el-table-column>

            <el-table-column
              label="Name"
              prop="name"
              sortable
              min-width="100px"
            >
              <template v-slot="{ row }">
                <img
                  @error="replaceImageWithIcon"
                  class="favicon-img"
                  :src="row.faviconUrl"
                />
                <i style="display: none;" class="ni ni-app component-icon"></i>

                {{ row.name }}
              </template>
            </el-table-column>

            <el-table-column
              label="Latency"
              prop="latency"
              sortable
              min-width="120px"
            >
              <template v-slot="{ row }">
                <span v-if="row.latency">{{ row.latency }} ms</span>

                <span v-else>
                  ? ms
                </span>
              </template>
            </el-table-column>

            <!--
            <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column">
            </el-table-column>
            -->
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <!--
          <div class="">
            <p class="card-category">
              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{ selectedRows.length }} components selected
              </span>
            </p>
          </div>-->
          <base-pagination
            class="pagination-no-border"
            :current="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @change="paginationChanged($event)"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    disabled: false
  },
  data() {
    return {
      propsToSearch: ["name", "email", "age"],
      tableData: [],
      tableColumns: [
        {
          type: "selection"
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 160,
          sortable: true
        },
        {
          prop: "latency",
          label: "Latency",
          minWidth: 220,
          sortable: true
        }
      ],
      selectedRows: [],
      selectedRowIds: [],
      checked: []
    };
  },
  mounted() {
    this.$http.get(`/setup`).then((response) => {
      console.log("Response received!");
      console.log(response.data);
      this.tableData = response.data.data;
    });
  },

  computed: {
    queriedData() {
      console.log("QUERIED DATA");

      let result = this.tableData;
      if (this.searchQuery) {
        result = this.searchedData;
      }
      console.log(result);

      const tableData = [];
      for (const c of result) {
        let row = {
          name: c.name,
          faviconUrl: c.faviconUrl,
          id: c.id,
          selected: true
        };

        if (c.pings && c.pings.length > 0) {
          row.latency = c.pings[0].duration;
        }

        console.log("Updating table data...");
        tableData.push(row);
        console.log(tableData);
      }

      return tableData.slice(this.from, this.to);
    }
  },

  methods: {
    isRowSelectable(row, index) {
      if (!this.disabled) return true;
      console.log("IS ROW SELECTALE");
      console.log(this.selectedRows);
      console.log(row);
      console.log(index);

      const selectedIds = this.selectedRows.map((row) => row.id);
      console.log("Checking if " + row.id + " is in " + selectedIds);
      console.log(selectedIds);
      if (selectedIds.includes(row.id)) {
        console.log("OMFG IT IS");
        return true;
      }
      return false;
    },
    replaceImageWithIcon(event) {
      console.log("Awesome");
      console.log(event);
      //event.target.src = "";
      event.target.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
      event.target.style = "display:none";
      event.target.nextSibling.style = "display: inline";
    },
    paginationChanged(page) {
      console.log("Pagination changed.");
      this.pagination.currentPage = page;
    },
    handleLike(index, row) {},
    handleEdit(index, row) {},
    handleDelete(index, row) {},
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows, row) {
      this.selectedRows = selectedRows;
      this.$emit("apiSelected", this.selectedRows);
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

.favicon-img {
  width: 16px;
}
.component-icon {
  color: #5e71e4 !important;
}
</style>
